export default function Logger(isDebugMode)
{
    
    this.isDebugMode = isDebugMode;

    this.log = function(caller, logText)
    {
        if(this.isDebugMode){
            console.log(caller, logText);
        }
    }.bind(this);
}